<bk-modal [title]="'Edit ' + (title | titlize)" (closed)="bsModalRef.hide()">
  <div *ngIf="allSelectable">
    <input type="checkbox" class="form-check-input" [(ngModel)]="selectedAll" (change)="selectAll()">
    <label class="form-label">&nbsp;&nbsp;All</label>
  </div>
  <div class="mb-2" *ngFor="let item of list; index as i">
    <input type="checkbox" class="form-check-input" (change)="selectItem(i, $event.target.checked)"
      [checked]="selected?.indexOf(item[this.bindValue]) != -1">
    <label class="form-label">&nbsp;&nbsp;{{item[this.bindLabel]}}</label>
  </div>
  <div bk-modal-footer class="d-flex justify-content-end gap-2">
    <button type="button" bkButton aria-label="Close" (click)="onSave()">
      Save
    </button>
  </div>
</bk-modal>
